import React from "react";
import {
  Select,
  Checkbox,
  List,
  Col,
  Row,
  Table,
  Button,
  Space,
  Input,
  Modal,
  message,
  Tag,
  Form,
  InputNumber,
  Grid,
} from "antd";
import { connect } from "react-redux";
import {
  requestServerPost,
  selectPage,
  requestNodeServerPost,
  requestServerGet,
} from "../../actions";
import PlaylistTableView from "../views/PlaylistTableView";
import Column from "antd/lib/table/Column";
import ActionButton from "../ActionButton";
import "./PlaylistSelectorPopup.css";
import PopupManager from "../../managers/PopupManager";
import DataHelper from "../../helpers/DataHelper";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import PermissionManager from "../../managers/PermissionManager";
import Colors from "../../config/Colors";
import {
  useProLanguage,
  PRO_TRANSLATIONS,
} from "../../global/ProLanguageContext";

const { Option } = Select;

const { confirm } = Modal;

const getColumns = (t, isMobile) => {
  if (isMobile) {
    return [
      {
        title: t.colScreenName,
        dataIndex: "ScreenName",
        render: (value, row, index) => {
          return (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: 6,
                padding: "2px 0",
              }}
            >
              <Space>
                <img
                  style={{ width: "18px" }}
                  src="/cms/assets/svgs/icons/screen_icon.svg"
                ></img>
                <span style={{ fontWeight: 500 }}>{value}</span>
              </Space>
              {row.EventPlaylistNames && row.EventPlaylistNames.length > 0 && (
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    flexWrap: "wrap",
                    paddingLeft: "30px",
                  }}
                >
                  {row.EventPlaylistNames}
                </div>
              )}
            </div>
          );
        },
      },
    ];
  }

  return [
    {
      title: t.colScreenName,
      dataIndex: "ScreenName",
      render: (value, row, index) => {
        return (
          <Space>
            <img
              style={{ width: "20px", marginRight: "16px" }}
              src="/cms/assets/svgs/icons/screen_icon.svg"
            ></img>
            {value}
          </Space>
        );
      },
    },
    {
      title: t.colCurrentEvents,
      dataIndex: "EventPlaylistNames",
      render: (value, row, index) => {
        return (
          <div style={{ width: "100%", display: "flex", flexWrap: "wrap" }}>
            {value}
          </div>
        );
      },
    },
  ];
};
class ScreenEventPlaylistSelectorPopup extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      screenDatas: [],
      screenEventPlaylists: [],
      selectedRowKeys: [], // Check here to configure the default column
      loading: false,
      screenNameFilter: "",
      toSetPriority: 1,
      overridePriority: false,
    };
  }

  componentDidMount() {
    this.reloadScreens();
  }

  checkContainsForiegnScreens = () => {
    const { data = null } = this.props;

    return this.state.selectedRowKeys.some((screenID) => {
      const sDatas = this.state.screenEventPlaylists.filter((sDat) => {
        return sDat.ScreenID === screenID;
      });
      return sDatas.every(
        (sData) => sData.EventPlaylistID !== data.EventPlaylistID,
      );
    });
  };

  validateSelectingAll = () => {
    const screensWithEventPlaylist = this.getScreensWithThisEventPlaylist();
    const containForiengScreens = this.checkContainsForiegnScreens();

    console.log("containForiengScreens " + containForiengScreens);
    return (
      this.state.selectedRowKeys.length === screensWithEventPlaylist.length &&
      !containForiengScreens
    );
  };

  reloadScreens = async (doUpdateSelections = true) => {
    const { selectedBrandData, selectedBranchData } = this.props;

    await this.reloadScreenEventPlaylists();
    DataHelper.getScreens(
      {
        brandid: selectedBrandData.BrandID,
        branchid: selectedBranchData.BranchID,
      },
      this.props,
    ).then((data) => {
      this.setState(
        { screenDatas: data },
        doUpdateSelections ? this.selectScreensWithThisEventPlaylist : () => {},
      );
    });
  };

  reloadScreenEventPlaylists = async () => {
    const {
      requestServerGet,
      usertoken,
      selectedBrandData,
      selectedBranchData,
    } = this.props;

    return new Promise((resolve, reject) => {
      requestServerGet(
        "get_screeneventplaylists",
        {
          brandid: selectedBrandData.BrandID,
          branchid: selectedBranchData.BranchID,
        },
        {},
        (response) => {
          this.setState({ screenEventPlaylists: response.data });
          resolve();
        },
        usertoken,
      );
    });
  };

  getScreensWithThisEventPlaylist = () => {
    // const { data = null } = this.props;
    // return this.state.screenDatas.filter(s => { return s.EventPlaylistID === data.EventPlaylistID }).map((sData, index) => sData.ScreenID)

    const {
      requestServerGet,
      usertoken,
      selectedBrandData,
      selectedBranchData,
      data = null,
    } = this.props;

    const filteredData = this.state.screenEventPlaylists.filter((d) => {
      return d.EventPlaylistID === data.EventPlaylistID;
    });
    return filteredData.map((sData, index) => sData.ScreenID);
  };

  selectScreensWithThisEventPlaylist = async () => {
    const { data = null } = this.props;
    const screenWithEventPlaylist = this.getScreensWithThisEventPlaylist();
    this.setState({ selectedRowKeys: screenWithEventPlaylist });
  };
  filter = (inputValue, path) => {
    return path.some(
      (option) =>
        option.label.toLowerCase().indexOf(inputValue.toLowerCase()) > -1,
    );
  };

  onChange = (value, selectedOptions) => {
    const { onChange } = this.props;
    onChange(value, selectedOptions);
  };

  renderList = () => {
    const { onItemSelected = () => {} } = this.props;
    const mappedData = this.state.screenDatas.map((d) => {
      return { ...d, key: d.ScreenID };
    });
    return (
      <List
        size="medium"
        header={<div>Select Screens To Assign to</div>}
        footer={<div></div>}
        bordered
        dataSource={mappedData}
        renderItem={(item) => (
          <div
            onClick={() => {
              onItemSelected(item);
              PopupManager.closePopup();
            }}
            className="center-content playlist-choice"
            style={{
              padding: "2px",
              border: "1px solid #f0f0f0",
              borderRadius: "4px",
            }}
          >
            <Row
              align="middle"
              justify="space-between"
              gutter={[4, 0]}
              style={{ width: "95%", height: "30px", cursor: "pointer" }}
            >
              <Col span={20}>
                <img
                  style={{ width: "20px", height: "20px", marginRight: "16px" }}
                  src="/cms/assets/svgs/icons/screen_icon.svg"
                ></img>
                {item.ScreenName}
              </Col>
            </Row>
          </div>
        )}
      />
    );
  };

  assignToScreens = () => {
    const {
      requestServerPost,
      usertoken,
      data = null,
      selectedBrandData,
      selectedBranchData,
    } = this.props;

    if (!data) return;
    const params = new FormData();
    const screenids = this.state.selectedRowKeys.join(",");

    var arr = [{ screenids: screenids, eventplaylistid: data.EventPlaylistID }];

    params.append("brandid", selectedBrandData.BrandID);
    params.append("branchid", selectedBranchData.BranchID);
    params.append("screens", JSON.stringify(arr));
    params.append("priority", this.state.toSetPriority);
    params.append("overridepriority", this.state.overridePriority);

    requestServerPost(
      "assign_eventplaylisttoscreens",
      params,
      {},
      (response) => {
        this.reloadScreens(false);
      },
      usertoken,
    );
  };

  save = () => {
    const { brandid, data = null } = this.props;
    const t = this.props.langT || PRO_TRANSLATIONS.en.assignEventToScreens;
    const hasOverrides = this.state.selectedRowKeys.some((screenID) => {
      const sData = this.state.screenDatas.find((sDat) => {
        return sDat.ScreenID === screenID;
      });
      return (
        sData.EventPlaylistID !== data.EventPlaylistID &&
        sData.EventPlaylistID !== ""
      );
    });

    if (hasOverrides) {
      Modal.confirm({
        title: t.confirmTitle,
        icon: <ExclamationCircleOutlined />,
        content: t.confirmReplace(data.EventPlaylistName),
        okText: t.ok,
        cancelText: t.cancel,
        onOk: this.assignToScreens,
      });
    } else {
      this.assignToScreens();
    }
  };

  publish = () => {
    const t = this.props.langT || PRO_TRANSLATIONS.en.assignEventToScreens;
    const selectedScreens = this.state.selectedRowKeys.map((screenID) => {
      return this.state.screenDatas.find((sDat) => {
        return sDat.ScreenID === screenID;
      });
    });

    Modal.confirm({
      title: t.confirmTitle,
      icon: <ExclamationCircleOutlined />,
      content: t.confirmPublish(selectedScreens.length),
      okText: t.ok,
      cancelText: t.cancel,
      onOk: () => {
        DataHelper.publishContent(
          selectedScreens,
          () => {
            message.success(t.publishSuccess(selectedScreens.length));
          },
          this.props,
        );
      },
    });
  };

  onSelectChange = (selectedRowKeys) => {
    this.setState({ selectedRowKeys });
  };

  onSelectEventPlaylistScreensChanged = (e) => {
    const checked = e.target.checked;

    if (checked) {
      this.selectScreensWithThisEventPlaylist();
    }
  };

  updateFilter = (e) => {
    const filter = e.target.value;
    this.setState({ screenNameFilter: filter });
  };

  showConfirm = (message = `Do you want to remove this data?`, callback) => {
    confirm({
      title: message,
      icon: <ExclamationCircleOutlined />,
      onOk() {
        callback();
      },
      onCancel() {
        console.log("Cancel");
      },
    });
  };

  handleDeleteScreenPlaylist = (screenEventplaylist) => {
    const t = this.props.langT || PRO_TRANSLATIONS.en.assignEventToScreens;
    this.showConfirm(
      t.removeConfirm(screenEventplaylist.EventPlaylistName),
      () => {
        this.deleteScreenEventPlaylist(screenEventplaylist);
      },
    );
  };

  deleteScreenEventPlaylist = (screenEventsData) => {
    const { requestServerPost, usertoken } = this.props;
    const params = new FormData();
    const { ScreenEventPlaylistID } = screenEventsData;

    params.append("screeneventplaylistid", ScreenEventPlaylistID);

    requestServerPost(
      "delete_screeneventplaylist",
      params,
      {},
      (response) => {
        console.log("delete_screeneventplaylist success ");
        // onSaved();
        this.reloadScreens();
      },
      usertoken,
    );
  };

  render() {
    const { data, isMobile } = this.props;
    const { loading, selectedRowKeys } = this.state;
    const t = this.props.langT || PRO_TRANSLATIONS.en.assignEventToScreens;
    const columns = getColumns(t, isMobile);

    console.log("render data " + JSON.stringify(data));
    const rowSelection = {
      selectedRowKeys,
      onChange: this.onSelectChange,
      selections: [
        Table.SELECTION_ALL,
        Table.SELECTION_INVERT,
        {
          key: "all_eventplaylist",
          text: t.selectScreensWithEvent(data.EventPlaylistName),
          onSelect: (changableRowKeys) => {
            const screensWithThisEventPlaylist =
              this.getScreensWithThisEventPlaylist();
            this.setState({ selectedRowKeys: screensWithThisEventPlaylist });
          },
        },
      ],
      preserveSelectedRowKeys: true,
    };
    const hasSelected = selectedRowKeys.length > 0;
    const isSelectingAll = this.validateSelectingAll();

    const containForiengScreens = this.checkContainsForiegnScreens();
    const needSave = containForiengScreens;

    const allowPublishPermission = PermissionManager.checkPermission(
      PermissionManager.PERMISSION_KEY_EVENT,
      PermissionManager.PERMISSION_TYPE_PUBLISH,
    );
    const canPublish = !needSave && hasSelected;

    const mappedData = this.state.screenDatas
      .map((d, index) => {
        const eventplaylistnames = this.state.screenEventPlaylists
          .filter(
            (screeneventplaylist) =>
              screeneventplaylist.ScreenID === d.ScreenID,
          )
          .map((filteredSEPlaylist) => {
            return (
              <div style={{ padding: "2px" }}>
                <Tag
                  color={
                    filteredSEPlaylist.EventPlaylistID === data.EventPlaylistID
                      ? Colors.teal
                      : Colors.lightgray
                  }
                  closable
                  onClose={(e) => {
                    e.preventDefault();
                    this.handleDeleteScreenPlaylist(filteredSEPlaylist);
                  }}
                >{`${filteredSEPlaylist.EventPlaylistName} (${filteredSEPlaylist.Priority})`}</Tag>
              </div>
            );
          });
        return {
          ...d,
          key: d.ScreenID,
          EventPlaylistNames: eventplaylistnames,
        };
      })
      .filter((sData) => {
        return sData.ScreenName.toLocaleLowerCase().includes(
          this.state.screenNameFilter.toLocaleLowerCase(),
        );
      });
    // .sort((a, b) => {
    //     const aValue = (this.state.selectedRowKeys.indexOf(a.ScreenID) > -1) ? -1 : 0
    //     const bValue = (this.state.selectedRowKeys.indexOf(b.ScreenID) > -1) ? -1 : 0

    //     return aValue - bValue
    // })

    return (
      // <Cascader
      //     options={this.state.playlistOptions}
      //     onChange={this.onChange}
      //     placeholder="Select Playlist"
      //     showSearch={this.filter}
      // />
      <div style={{ margin: isMobile ? 12 : 24 }}>
        <div style={{ marginBottom: 16 }}>
          <Space>
            <Space>
              <Button
                type="primary"
                onClick={this.save}
                disabled={!needSave}
                loading={loading}
              >
                {t.assignTo}
              </Button>
              {allowPublishPermission ? (
                <Button
                  type="primary"
                  onClick={this.publish}
                  disabled={!canPublish}
                  loading={loading}
                >
                  {t.publish}
                </Button>
              ) : null}
            </Space>
          </Space>
          <span style={{ marginLeft: 8 }}>
            {hasSelected ? t.selected(selectedRowKeys.length) : ""}
          </span>
        </div>
        <Input
          onChange={this.updateFilter}
          value={this.state.screenNameFilter}
          placeholder={t.filterPlaceholder}
          style={{ marginBottom: "8px" }}
        ></Input>
        <Table
          style={isMobile ? undefined : { whiteSpace: "pre" }}
          className="event-screen-select-table"
          rowSelection={rowSelection}
          columns={columns}
          dataSource={mappedData}
        />
        <Checkbox
          onChange={this.onSelectEventPlaylistScreensChanged}
          checked={isSelectingAll}
        >
          {t.everyScreen(data.EventPlaylistName)}
        </Checkbox>
        <Form
          style={{ marginTop: "20px" }}
          // {...formItemLayout}
          layout="inline"
        >
          <Form.Item label={t.assignWithPriority}>
            <InputNumber
              style={{ borderRadius: "5px" }}
              min={1}
              defaultValue={1}
              value={this.state.toSetPriority}
              onChange={(value) => {
                this.setState({ toSetPriority: value });
              }}
            />
          </Form.Item>
          <Form.Item label={t.overridePriorities}>
            <Checkbox
              checked={this.state.overridePriority}
              onChange={(value) => {
                this.setState({
                  overridePriority: !this.state.overridePriority,
                });
              }}
            ></Checkbox>
          </Form.Item>
        </Form>
      </div>
      // <>{this.renderList()}</>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    userdata: state.userdata,
    usertoken: state.usertoken,
    selectedBrandData: state.selectedBrandData,
    selectedBranchData: state.selectedBranchData,
    selectedBranchData: state.selectedBranchData,
  };
};

const ConnectedScreenEventPlaylistSelectorPopup = connect(mapStateToProps, {
  requestServerGet,
  requestServerPost,
  selectPage,
  requestNodeServerPost,
})(ScreenEventPlaylistSelectorPopup);

const ScreenEventPlaylistSelectorPopupWithLang = (props) => {
  const { lang } = useProLanguage();
  const t =
    PRO_TRANSLATIONS[lang]?.assignEventToScreens ||
    PRO_TRANSLATIONS.en.assignEventToScreens;
  const screens = Grid.useBreakpoint();
  const isMobile = screens.sm === false;
  return (
    <ConnectedScreenEventPlaylistSelectorPopup
      langT={t}
      isMobile={isMobile}
      {...props}
    />
  );
};

export default ScreenEventPlaylistSelectorPopupWithLang;
